export var typographyTokens = {
  size: {
    xs: '1rem',
    s: '1.2rem',
    m: '1.4rem',
    l: '1.6rem',
    xl: '1.8rem',
    '2xl': '2rem',
    '3xl': '2.2rem',
    '4xl': '2.4rem',
    '5xl': '2.8rem',
    '6xl': '3.2rem',
    '7xl': '3.6rem'
  },
  weight: {
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800,
    black: 900
  },
  family: {
    normal: 'Inter var, Inter, helvetica, arial, sans-serif',
    mono: 'Monaco, monospace'
  },
  lineHeight: {
    xs: '1.4rem',
    s: '1.6rem',
    m: '2rem',
    l: '2.4rem',
    xl: '2.6rem',
    '2xl': '2.8rem',
    '3xl': '3rem',
    '4xl': '3.6rem',
    '5xl': '4rem'
  },
  letterSpacing: {
    compact: '-.05rem',
    normal: '0',
    wide: '.05rem'
  }
};